import React from "react";
import { cn } from "@porchpass/ui";

type BadgeVariant = "on-letter" | "off-letter" | "correction" | "pending-sync";

const VARIANT_STYLES: Record<BadgeVariant, string> = {
  "on-letter": "bg-[#E6F7EE] text-[#1A7F4B]",
  "off-letter": "bg-[#F3F5F8] text-[#697083]",
  correction: "bg-[#FEF2F2] text-[#B91C1C]",
  "pending-sync": "bg-[#FEF3C7] text-[#B45309]",
};

interface PreApprovalBadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
}

export function PreApprovalBadge({
  variant,
  children,
  className,
  icon,
}: PreApprovalBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide",
        VARIANT_STYLES[variant],
        className,
      )}
    >
      {icon}
      {children}
    </span>
  );
}
